import { getImageUrl } from "src/Common/common";

const AttachmentViewButton = ({ isBlue, clicked }) => {
  return (
    <div onClick={isBlue ? clicked : undefined} className={`w-[34px] h-[32px] rounded-[6px] border-solid border-[1px] border-borderColor flex items-center justify-center relative ${isBlue ? "bg-blueColor text-white cursor-pointer" : "cursor-not-allowed"}`}>
      <img src={isBlue ? getImageUrl("/images/common/white_view.png") : getImageUrl("/images/common/view.png")} style={{ width: "18px", height: "18px" }} />
    </div>
  );
};

export default AttachmentViewButton;